import * as moment from "moment";
import {isMobileDevice} from "../layout/device";
import {
    BPParam,
    DeeplinkData,
    DeeplinkPerson,
    DeeplinkResponse
} from "../typings/deeplink/deeplink";
import {getCanal} from "../tools/Booking";

/**
 * deeplink action for resa
 * add sales process parameters
 */
export function deeplinkAction(query: JQuery<HTMLElement>) {
    // sales process parameters
    addSalesProcessParameters(query);
}

/**
 * add sales process parameters
 */
function addSalesProcessParameters(bookingForm: JQuery<HTMLElement>) {
    const data: DeeplinkData = {};
    const persons: DeeplinkPerson[] = [];
    const pathname = window.location.pathname;
    let isB2b = false;
    if (pathname && pathname.indexOf("/b2b") !== -1) {
        isB2b = true;
    }

    const travellers = bookingForm.serializeArray().filter(item => item.name.startsWith("traveller[") && item.name.endsWith("].type"));
    const birthDates = bookingForm.serializeArray().filter(item => item.name.startsWith("traveller[") && item.name.endsWith("].birthDate"));

    for (let i = 0; i < travellers.length; i++) {
        if (travellers[i].value === "A") {
            persons.push({
                type: "ADULT"
            });
        } else if (travellers[i].value === "C") {
            const birthDate = birthDates.filter(item => item.name === "traveller[" + i + "].birthDate");
            if (birthDate.length === 1) {
                const formattedBirthDate = moment(birthDate[0].value, "DD-MM-YYYY").format("YYYY-MM-DD");
                if (moment(birthDate[0].value, "DD-MM-YYYY").isValid()) {
                    persons.push({
                        type: "CHILD",
                        birthdate: formattedBirthDate
                    });
                }

            }
        }

    }

    const dispo = (bookingForm.find("input[name='disponibility']").val() as string).split("-");
    data.deviceType = isMobileDevice() ? "MOBILE" : "DESKTOP";
    data.url = window.location.href;
    data.bookingRequest = {
        productCatalogCode: Number(bookingForm.find("input[name='catalogCode']").val() as string),
        avail: {
            departureDate:`${dispo[2]}-${dispo[1]}-${dispo[0]}`,
            daysNumber: Number(dispo[3]),
            nightsNumber: Number(dispo[4]),
            departureCityCode: bookingForm.find("input[name='depCityCode']").val() as string,
        },
        quantity: {
            persons,
            type: "persons"
        }
    };
    data.extra = {
        "isB2b" : isB2b
    };

    const canal = getCanal();
    if (canal !== "") {
        data.bpConfig = {
            profileChannel: canal,
        };
    }

    void $.ajax("/deeplink/v2/package", {
        method: "POST",
        data: JSON.stringify(data),
        contentType: "application/json",
        dataType: "json",
        statusCode: {
            401: () => {
                console.log("Unauthorized, redirecting...");
                window.location.reload();
            }
        }
    }).done((response: DeeplinkResponse) => {
        submitResa(response.bpUrl, response.bpParams, response.bpRequestMethod);
    });
}

/**
 * sends a request to the specified url from a form. this will change the window location.
 * @param {string} path the path to send the post request to
 * @param {object} params the parameters to add to the url
 * @param method
 */
function submitResa(path: string, params: BPParam[], method: string) {

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement("form");
    form.method = method;
    form.action = path;

    for (const item of params) {

        const hiddenField = document.createElement("input");
        hiddenField.type = "hidden";
        hiddenField.name = item.name;
        hiddenField.value = item.value;

        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
}
